import { render, staticRenderFns } from "./NewAddLabelAction.vue?vue&type=template&id=134e5f09&"
import script from "./NewAddLabelAction.vue?vue&type=script&lang=js&"
export * from "./NewAddLabelAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports